export default __webpack_public_path__ + "static/media/save.af2a99cd.svg";